// src/components/IconSelector/iconos.js
// Lista curada de íconos FontAwesome para e-commerce

// Lista de íconos de marcas (redes sociales) que usan el prefijo 'fab'
const brandIcons = [
	'fa-whatsapp', 'fa-facebook', 'fa-facebook-messenger', 'fa-instagram',
	'fa-twitter', 'fa-x-twitter', 'fa-tiktok', 'fa-youtube', 'fa-linkedin',
	'fa-pinterest', 'fa-telegram', 'fa-snapchat', 'fa-discord', 'fa-threads'
]

/**
 * Obtiene la clase CSS completa para un ícono FontAwesome
 * @param {string} iconValue - El valor del ícono (ej: 'fa-whatsapp')
 * @returns {string} La clase completa (ej: 'fab fa-whatsapp' o 'fas fa-truck')
 */
export const getIconClass = (iconValue) => {
	if (!iconValue) return ''
	const isBrand = brandIcons.includes(iconValue)
	const prefix = isBrand ? 'fab' : 'fas'
	return `${prefix} ${iconValue}`
}

export const iconosFontAwesome = [
	// Pagos y dinero
	{ value: 'fa-hand-holding-dollar', label: 'Pago en mano' },
	{ value: 'fa-credit-card', label: 'Tarjeta de crédito' },
	{ value: 'fa-money-bill', label: 'Efectivo' },
	{ value: 'fa-money-bill-wave', label: 'Dinero' },
	{ value: 'fa-wallet', label: 'Billetera' },
	{ value: 'fa-coins', label: 'Monedas' },
	{ value: 'fa-piggy-bank', label: 'Alcancía' },
	{ value: 'fa-percent', label: 'Porcentaje / Descuento' },
	{ value: 'fa-tags', label: 'Etiquetas / Ofertas' },
	{ value: 'fa-tag', label: 'Etiqueta' },

	// Envíos y transporte
	{ value: 'fa-truck', label: 'Camión' },
	{ value: 'fa-truck-fast', label: 'Envío rápido' },
	{ value: 'fa-truck-ramp-box', label: 'Camión con caja' },
	{ value: 'fa-box', label: 'Caja' },
	{ value: 'fa-boxes-stacked', label: 'Cajas apiladas' },
	{ value: 'fa-dolly', label: 'Carrito de carga' },
	{ value: 'fa-motorcycle', label: 'Moto' },
	{ value: 'fa-bicycle', label: 'Bicicleta' },
	{ value: 'fa-plane', label: 'Avión' },
	{ value: 'fa-location-dot', label: 'Ubicación' },
	{ value: 'fa-map-marker-alt', label: 'Marcador de mapa' },
	{ value: 'fa-globe', label: 'Global / Mundial' },

	// Atención al cliente
	{ value: 'fa-headset', label: 'Soporte / Auriculares' },
	{ value: 'fa-phone', label: 'Teléfono' },
	{ value: 'fa-phone-volume', label: 'Llamada' },
	{ value: 'fa-comments', label: 'Chat' },
	{ value: 'fa-comment', label: 'Mensaje' },
	{ value: 'fa-envelope', label: 'Email' },
	{ value: 'fa-user-headset', label: 'Atención al cliente' },
	{ value: 'fa-question-circle', label: 'Ayuda' },
	{ value: 'fa-info-circle', label: 'Información' },

	// Seguridad y garantía
	{ value: 'fa-shield', label: 'Escudo' },
	{ value: 'fa-shield-halved', label: 'Escudo protección' },
	{ value: 'fa-lock', label: 'Candado' },
	{ value: 'fa-check-circle', label: 'Verificado' },
	{ value: 'fa-certificate', label: 'Certificado' },
	{ value: 'fa-award', label: 'Premio' },
	{ value: 'fa-medal', label: 'Medalla' },
	{ value: 'fa-star', label: 'Estrella' },

	// Tiempo
	{ value: 'fa-clock', label: 'Reloj' },
	{ value: 'fa-hourglass-half', label: 'Reloj de arena' },
	{ value: 'fa-calendar', label: 'Calendario' },
	{ value: 'fa-calendar-check', label: 'Fecha confirmada' },
	{ value: 'fa-stopwatch', label: 'Cronómetro' },

	// Compras
	{ value: 'fa-cart-shopping', label: 'Carrito' },
	{ value: 'fa-basket-shopping', label: 'Canasta' },
	{ value: 'fa-bag-shopping', label: 'Bolsa de compras' },
	{ value: 'fa-store', label: 'Tienda' },
	{ value: 'fa-shop', label: 'Local' },
	{ value: 'fa-receipt', label: 'Recibo' },
	{ value: 'fa-barcode', label: 'Código de barras' },

	// Redes sociales (usan fab - Font Awesome Brands)
	{ value: 'fa-whatsapp', label: 'WhatsApp', brand: true },
	{ value: 'fa-facebook', label: 'Facebook', brand: true },
	{ value: 'fa-facebook-messenger', label: 'Messenger', brand: true },
	{ value: 'fa-instagram', label: 'Instagram', brand: true },
	{ value: 'fa-twitter', label: 'Twitter', brand: true },
	{ value: 'fa-x-twitter', label: 'X (Twitter)', brand: true },
	{ value: 'fa-tiktok', label: 'TikTok', brand: true },
	{ value: 'fa-youtube', label: 'YouTube', brand: true },
	{ value: 'fa-linkedin', label: 'LinkedIn', brand: true },
	{ value: 'fa-pinterest', label: 'Pinterest', brand: true },
	{ value: 'fa-telegram', label: 'Telegram', brand: true },
	{ value: 'fa-snapchat', label: 'Snapchat', brand: true },
	{ value: 'fa-discord', label: 'Discord', brand: true },
	{ value: 'fa-threads', label: 'Threads', brand: true },

	// Contacto adicional
	{ value: 'fa-at', label: 'Arroba / Email' },
	{ value: 'fa-envelope-open', label: 'Email abierto' },
	{ value: 'fa-mobile', label: 'Celular' },
	{ value: 'fa-mobile-screen', label: 'Celular con pantalla' },
	{ value: 'fa-phone-flip', label: 'Teléfono volteado' },
	{ value: 'fa-square-phone', label: 'Teléfono cuadrado' },

	// General
	{ value: 'fa-heart', label: 'Corazón' },
	{ value: 'fa-thumbs-up', label: 'Me gusta' },
	{ value: 'fa-hand-holding-heart', label: 'Cuidado' },
	{ value: 'fa-gift', label: 'Regalo' },
	{ value: 'fa-gem', label: 'Gema / Premium' },
	{ value: 'fa-crown', label: 'Corona / VIP' },
	{ value: 'fa-bolt', label: 'Rayo / Rápido' },
	{ value: 'fa-fire', label: 'Fuego / Hot' },
	{ value: 'fa-leaf', label: 'Hoja / Eco' },
	{ value: 'fa-recycle', label: 'Reciclaje' },
	{ value: 'fa-handshake', label: 'Acuerdo' },
	{ value: 'fa-users', label: 'Usuarios' },
	{ value: 'fa-user', label: 'Usuario' },
	{ value: 'fa-house', label: 'Casa' },
	{ value: 'fa-building', label: 'Edificio' },
	{ value: 'fa-industry', label: 'Industria' },
	{ value: 'fa-tools', label: 'Herramientas' },
	{ value: 'fa-wrench', label: 'Llave' },
	{ value: 'fa-cog', label: 'Engranaje' },
	{ value: 'fa-check', label: 'Check' },
	{ value: 'fa-times', label: 'X / Cerrar' },
	{ value: 'fa-plus', label: 'Más' },
	{ value: 'fa-minus', label: 'Menos' },
	{ value: 'fa-arrow-right', label: 'Flecha derecha' },
	{ value: 'fa-arrow-left', label: 'Flecha izquierda' },
]
